import script from "./completion_modal.vue?vue&type=script&setup=true&lang=js"
export * from "./completion_modal.vue?vue&type=script&setup=true&lang=js"

import "./completion_modal.vue?vue&type=style&index=0&id=c9e5ab0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9e5ab0e"]])

export default __exports__